module.exports = __webpack_public_path__ + "media/shipin4.5aad839c.mp4";